export function vm(){
	const v = new Vue({
		el: '#site-header',
		data: {
			toggle: false,
		}
	});
}